import React, {useEffect, useState} from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { formatDate, formatTime } from '../helpers/Helpers';
import { SERVER_URL } from '../constants';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import OfficeTodaysFixedScheduleTimeSlotList from './OfficeTodaysFixedScheduleTimeSlotList';
import GenerateFixedSchedLink from './GenerateFixedSchedLink';
import AddTimeSlot from './AddTimeSlot';
import { REFRESH_SECONDS } from '../constants';
import EditTodaysSchedule from './EditTodaysSchedule';

function OfficeTodaysFixedSchedule (props) {

    // useEffect(() => {
    //     props.fetchOffices();
    // }, [nowServing]);

    useEffect(() => {
        const interval = setInterval(() => {
            fetchTimeSlotList();
        }, 1000 * REFRESH_SECONDS);
        
        return () => clearInterval(interval);

    }, []);
  
    const [errorMessage, setErrorMessage] = useState("");
    const [snackbarOpen, setSnackbarOpen] = React.useState(false);

    const handleSnackbarOpen = () => {
        setSnackbarOpen(true);
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    const [message, setMessage] = useState("");

    const [latestTime, setLatestTime] = React.useState("");

    const [timeSlots, setTimeSlots] = useState([]);

    const fetchTimeSlotList = () => {
        console.log("fetchTimeSlotList()");
        setMessage("fetching data...");
        const token = sessionStorage.getItem("token");
        fetch(SERVER_URL + 'api/mod/list-timeslots/' + props.schedule.id, {
            method: 'GET',
            headers: { 
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization' : 'Bearer ' + token
            }
        })
        .then(response => response.json())
        .then(data => {
            // console.log("fetchTimeSlotList data.data", data.data);
            if (data.data.length > 0) {
                const mostRecentTime = data.data.reduce((latest, current) => {
                    return current.time > latest.time ? current : latest;
                }).time;
                setTimeSlots(data.data);
                setLatestTime(mostRecentTime);
                setMessage("");
            } else {
                if (data.data.length < 1) setMessage("No timeslots found");
            }
        })
        .catch(err => console.error(err));
    }

    return(
        <React.Fragment>
            <Box 
                sx={{ 
                display: 'flex', 
                flexDirection: 'column', 
                height: '100%' // or a fixed height if needed
                }}
            >

                <Box sx={{ p: 1 }}>
                    <Stack alignItems="center" justifyContent="center" direction="column" spacing={1}>
                        <Typography gutterBottom variant="subtitle1">
                        {formatDate(props.schedule.date)}
                        </Typography>
                    </Stack>
                </Box>
                <Box
                    sx={{
                    flexGrow: 1,          // take up remaining space
                    overflowY: 'auto',    // enable vertical scrollbars when content overflows
                    p: 2,                 // optional padding
                    }}
                >
                    <OfficeTodaysFixedScheduleTimeSlotList 
                        scheduleId={props.schedule.id}
                        officeName={props.officeName}
                        officeId={props.officeId}
                        rawDate={props.schedule.date}
                        fetchTimeSlotList={fetchTimeSlotList}
                        message={message}
                        timeSlots={timeSlots}
                    />
                </Box>
                <Box sx={{ p: 1, mt: 'auto' }}>
                    <Stack alignItems="center" justifyContent="center" direction="row" spacing={3}>
                        <GenerateFixedSchedLink setRecentAppLinkGenerate={props.setRecentAppLinkGenerate} fetchOffices={props.fetchOffices} officeId={props.officeId} officeName={props.officeName}/>
                        <AddTimeSlot startTime={props.schedule.start_time} averageServeMinutes={props.schedule.average_serve_minutes} latestTime={latestTime} fetchTimeSlotList={fetchTimeSlotList} scheduleId={props.schedule.id} date={formatDate(props.schedule.date)} rawDate={props.rawDate} />
                        <EditTodaysSchedule 
                            hideMaxClients={true}
                            maxClients={props.schedule.max_clients}
                            officeName={props.officeName} 
                            scheduleId={props.schedule.id} 
                            fetchOffices={props.fetchOffices} 
                            date={formatDate(props.schedule.date)} 
                            startTime={props.schedule.start_time} 
                            endTime={props.schedule.end_time} 
                            averageServeMinutes={props.schedule.average_serve_minutes}
                        />
                    </Stack>
                </Box>
            </Box>
            <Snackbar anchorOrigin={{ vertical:'top', horizontal:'center' }} open={snackbarOpen} autoHideDuration={3000} onClose={handleSnackbarClose}>
                <Alert
                onClose={handleSnackbarClose}
                severity="info"
                variant="filled"
                sx={{ width: '100%' }}
                >
                {errorMessage}
                </Alert>
            </Snackbar>

        </React.Fragment>
    );
}

export default OfficeTodaysFixedSchedule;